import CONSTANTS from 'utils/constants';
import defaultActions from './default';
import { getStationsByUser, updateStationByUser } from '../api/hdrainClient';

import { updateEntity as updateStationsUsersGroups } from './stationsUsersGroups';

const ENTITIES = 'STATIONS';
const ENTITY = 'STATION';
const Entity = 'Station';
const entityName = 'station';
const ENTITIES_COLLECTION = 'stations';

const fetchCollectionByStandardUser = getStationsByUser;
const updateEntityByUser = updateStationByUser;
const entityActions = defaultActions({
  ENTITIES,
  ENTITY,
  Entity,
  entityName,
  ENTITIES_COLLECTION,
  fetchCollectionByStandardUser,
  updateEntityByUser,
});
export const { ACTIONS_NAMES_DICT } = entityActions;

export const { ENTITY_ACTIONS } = entityActions;
export const { fetchEntities } = entityActions;

export const createEntity = (entity, options = {}) => {
  // Update stationsUsersGroups on success
  const { stationsUsersGroupsIdsToAdd } = options;

  const postSuccessHook = (params) => {
    return async (dispatch, getState) => {
      const _stationsUsersGroupsIdsToAdd = params.stationsUsersGroupsIdsToAdd;
      const stationId = params.entityId;
      const stationsUsersGroups = getState().stationsUsersGroups.data;
      // Loop over group to update the ones needed
      stationsUsersGroups.forEach((group) => {
        const newGroup = { ...group };
        const { id } = newGroup;
        if (_stationsUsersGroupsIdsToAdd.includes(id)) {
          // Add stationId to list
          const stationsIds = [...newGroup.stationsIds, stationId];
          // Add group to groupToUpdate
          newGroup.stationsIds = stationsIds;
          // Update group
          dispatch(updateStationsUsersGroups(newGroup));
        }
      });
      return true;
    };
  };

  const postSuccessParams = {
    stationsUsersGroupsIdsToAdd,
  };

  const postActionSuccess = {
    hook: postSuccessHook,
    params: postSuccessParams,
  };

  return async (dispatch, getState) => {
    const userDataRole = getState().auth.userData.role;

    const preCall = null;
    const hooks = {};
    // Trigger only for admin
    if (CONSTANTS.IS_USER_ROLE_ADMIN[userDataRole]) {
      hooks.postActionSuccess = postActionSuccess;
    }

    return dispatch(entityActions.createEntity(entity, preCall, hooks));
  };
};

export const updateEntity = (entity, options = {}) => {
  const stationId = entity.id;
  // Update stationsUsersGroups on success
  const {
    stationsUsersGroupsIdsToAdd,
    stationsUsersGroupsIdsToRemove,
  } = options;

  const postSuccessHook = (params) => {
    return async (dispatch, getState) => {
      const _stationsUsersGroupsIdsToAdd = params.stationsUsersGroupsIdsToAdd;
      const _stationsUsersGroupsIdsToRemove =
        params.stationsUsersGroupsIdsToRemove;

      const stationsusersGroups = getState().stationsUsersGroups.data;
      const stationsUsersGroupsToUpdate = [];

      // Loop over group to update the ones needed
      stationsusersGroups.forEach((group) => {
        const newGroup = { ...group };
        const { id } = newGroup;
        if (_stationsUsersGroupsIdsToAdd.includes(id)) {
          // Add stationId to list
          const stationsIds = [...newGroup.stationsIds, stationId];
          // Add group to groupToUpdate
          newGroup.stationsIds = stationsIds;
          stationsUsersGroupsToUpdate.push(newGroup);
        } else if (_stationsUsersGroupsIdsToRemove.includes(id)) {
          // Remove stationId from list
          const stationsIds = newGroup.stationsIds.filter(
            (groupStationId) => groupStationId !== stationId
          );

          // Add group to groupToUpdate
          newGroup.stationsIds = stationsIds;
          stationsUsersGroupsToUpdate.push(newGroup);
        }
      });

      // Update modified stationsUsersGroups
      stationsUsersGroupsToUpdate.forEach((group) => {
        dispatch(updateStationsUsersGroups(group));
      });
    };
  };

  const postSuccessParams = {
    stationsUsersGroupsIdsToAdd,
    stationsUsersGroupsIdsToRemove,
  };

  const postActionSuccess = {
    hook: postSuccessHook,
    params: postSuccessParams,
  };

  return async (dispatch, getState) => {
    const userDataRole = getState().auth.userData.role;

    const hooks = {};
    // Trigger only for admin
    if (CONSTANTS.IS_USER_ROLE_ADMIN[userDataRole]) {
      hooks.postActionSuccess = postActionSuccess;
    }
    return dispatch(entityActions.updateEntity(entity, hooks));
  };
};
export const { archiveEntity } = entityActions;
export const { entitiesCleanUp } = entityActions;
export const { clearEntitiesDataLogout } = entityActions;
